@if (showBackdrop()) {
  <div class="backdrop" [style.opacity]="backdropOpacity()"></div>
}
<div class="container">
  <svg class="spinner" [style.width.px]="size()" [style.height.px]="size()" viewBox="25 25 50 50">
    <circle class="spinner-circle" cx="50" cy="50" r="20" [attr.stroke-width]="strokeWidth()" />
  </svg>
</div>
